export const toGraphInputCreateRequest = ({
  tenantId,
  graphName,
  clientId,
  clientSecret,
  subscriptionType,
  content_type,
  readTimeOffset,
  graphThrottleEnabled,
  pollingInterval,
  timeoutGracePeriodMinutes
}) => {
  var _a;
  return {
    name: graphName.value,
    polling_interval: pollingInterval.value,
    tenant_id: tenantId.value,
    enable_throttling: !!(graphThrottleEnabled == null ? void 0 : graphThrottleEnabled.value),
    client_id: clientId.value,
    client_secret: clientSecret.value,
    subscription_type: subscriptionType.value,
    content_type: content_type.value.split(","),
    read_time_offset: readTimeOffset.value,
    timeout_grace_period_minutes: Number((_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : 5)
  };
};
export const toGenericInputCreateRequest = ({
  graphName,
  tenantId,
  clientId,
  clientSecret,
  subscriptionType,
  graphThrottleEnabled,
  pollingInterval,
  content_type,
  readTimeOffset,
  timeoutGracePeriodMinutes
}) => {
  var _a;
  return {
    type: "org.graylog.enterprise.integrations.microsoftgraph.GraphInput",
    title: graphName.value,
    global: false,
    configuration: {
      polling_interval: pollingInterval.value,
      tenant_id: tenantId.value,
      throttling_allowed: !!(graphThrottleEnabled == null ? void 0 : graphThrottleEnabled.value),
      client_id: clientId.value,
      client_secret: clientSecret.value,
      subscription_type: subscriptionType.value,
      content_type: content_type.value.split(","),
      read_time_offset: readTimeOffset.value,
      timeout_grace_period_minutes: Number((_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : 5)
    }
  };
};
